import { useState, useEffect } from 'react';
import { downloadFiles, getCustomerLeadgerData, getLedgerDivDetailsCPI, fetchProfitCenters } from '../../Service/ApiService';
import { showAlert } from 'utils/ErrorMessage';
import { showSuccessAlert } from 'utils/SuccessMessage';

const LedgerDivCPIController = (initialState, validate) => {
  const [formData, setFormData] = useState(initialState);
  const [customeroptions, setCustomerOptions] = useState([]);
  const [ledgerData, setLedgerData] = useState({});
  const [customerLoading, setCustomerLoading] = useState(false);
  const [ledgerLoading, setLedgerLoading] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const user = JSON.parse(localStorage.getItem('user'));
  const confvalue = JSON.parse(localStorage.getItem('confvalue'));
  const [searchText, setSearchText] = useState('');
  const [profitCenters, setProfitCenters] = useState([]);
  const [selectedProfitCenter, setSelectedProfitCenter] = useState('');
  const [profitCentersParam, setProfitCentersParam] = useState('');

  const cloading = customerLoading || ledgerLoading || downloadLoading;

  useEffect(() => {
    if (user.profitCenter != null) {
      getProfitCenters(user.profitCenter);
    }
  }, []);

  useEffect(() => {
    getCustomer();
  }, [searchText]);

  useEffect(() => {
    if (formData.customer == null || formData.customer == '') {
      fetchLedgerData(user.userCode, confvalue.confvertical, selectedProfitCenter.value);
    }
  }, [formData.customer, selectedProfitCenter]);

  // Show ledger details for garment user
  useEffect(() => {
    if (user.userVerticalId == "Garment") {
      fetchLedgerData(user.userCode, confvalue.confvertical, user.profitCenter);
    }
  }, []);

  const getProfitCenters = async (profitCentersParam) => {
    try {
      setLedgerLoading(true);
      const response = await fetchProfitCenters(profitCentersParam);
      setLedgerData({}); // Clear previous ledger data

      if (response && response.success) {
        // Map API response into { value, label } format for react-select
        const mappedProfitCenters = response.data.map(item => ({
          value: item.profitCenter,
          label: `${item.profitCenterName} - ${item.profitCenter}`
        }));
        setProfitCenters(mappedProfitCenters);

        setSelectedProfitCenter(mappedProfitCenters[0])
        setProfitCentersParam(mappedProfitCenters[0].value);

        fetchLedgerData(user.userCode, confvalue.confvertical, mappedProfitCenters[0].value);

        // If only one profit center, auto-select it
        if (mappedProfitCenters.length === 1) {
          setSelectedProfitCenter(mappedProfitCenters[0]);
          setProfitCentersParam(mappedProfitCenters[0]);
        }
      }

      setLedgerLoading(false);
    } catch (error) {
      console.error('Error fetching profit centers:', error);
      setLedgerLoading(false);
    }
  };

  const handleInputChange = (inputValue) => {
    setSearchText(inputValue);
  };

  const handleDownloadAll = async () => {
    setDownloadLoading(true);

    let param = '';

    if (user.userVerticalId == "Garment") {
      param = `userCode=${user.userCode}&partyCode=${user.userCode}&userVertical=${confvalue.confvertical}&profitCenter=${user.profitCenter == null || user.profitCenter === 'null' || user.profitCenter === 'undefined' ? '' : user.profitCenter}&isSFA=${user.isSFA}`;
    }
    else {
      param = `userCode=${user.userCode}&partyCode=${formData.customer.value || user.userCode}&userVertical=${confvalue.confvertical}&profitCenter=${selectedProfitCenter.value == null || selectedProfitCenter.value === 'null' || selectedProfitCenter.value === 'undefined' ? '' : selectedProfitCenter.value}&isSFA=${user.isSFA}`;
    }

    const response = await downloadFiles(param, 'LedgerDivDetailsDownloadCPI.php', 'ledgerFile.xls');
    if (response == true) {
      showSuccessAlert('File Downloaded Successfully', 'Download Ledger');
    }

    setDownloadLoading(false);
  };

  const getCustomer = async () => {
    try {
      setCustomerLoading(true);
      const response = await getCustomerLeadgerData(user.userCode, searchText, user.userVerticalId);
      if (response && response.success === 'true') {
        setCustomerOptions([]);
        const uniqueCustomerOptions = response.customerList.reduce((uniqueList, currentItem) => {
          // Check if the partyCode of the current item is already present in the unique list
          const existingItem = uniqueList.find((item) => item.value === currentItem.partyCode.toString());

          // If the partyCode is not already in the unique list, add it
          if (!existingItem) {
            uniqueList.push({
              value: currentItem.partyCode.toString(),
              label: currentItem.partyName + '-' + currentItem.city + '-' + currentItem.partyCode.toString()
            });
          }

          return uniqueList;
        }, []);
        setCustomerOptions(uniqueCustomerOptions);
      }
      setCustomerLoading(false);
    } catch (error) {
      setCustomerLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validate(formData);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      fetchLedgerData(formData.customer.value ?? user.userCode, confvalue.confvertical, selectedProfitCenter.value);
    }
  };

  const fetchLedgerData = async (customerCode, verticalId, profitCenter) => {
    try {
      setLedgerLoading(true);

      if (user.userVerticalId == 'Garment') {
        profitCenter = user.profitCenter;
      }

      const response = await getLedgerDivDetailsCPI(customerCode, verticalId, profitCenter, user.isSFA);
      setLedgerData({});
      if (response && response.success === 'true') {
        setLedgerData(response.data);
      } else {
        setLedgerData({});
        showAlert(response.msg);
      }
      setLedgerLoading(false);
    } catch (error) {
      console.error('Error fetching ledger data:', error);
      setLedgerLoading(false);
    }
  };

  const handleCustomerChange = (e) => {
    if (e) {
      setFormData({
        ...formData,
        ['customer']: e // Update formData with the selected customer
      });

      setErrors({
        ...errors,
        ['customer']: '' // Clear any existing errors
      });
    } else {
      setFormData({
        ...formData,
        ['customer']: null // Clear the customer field in formData
      });

      setErrors({
        ...errors,
        ['customer']: '' // You can set a validation error or reset it
      });

      setLedgerData({});
    }
  };

  const handleProfitCenterChange = (value) => {
    if (value) {
      setFormData({
        ...formData,
        ['profitCenters']: value // Update formData with the selected customer
      });

      setErrors({
        ...errors,
        ['profitCenters']: '' // Clear any existing errors
      });
    } else {
      setFormData({
        ...formData,
        ['profitCenters']: null // Clear the customer field in formData
      });

      setErrors({
        ...errors,
        ['profitCenters']: '' // You can set a validation error or reset it
      });

      setLedgerData({});
    }
    setSelectedProfitCenter(value);
    setProfitCentersParam(value ? value.value : '');
    fetchLedgerData(formData.customer.value ?? user.userCode, confvalue.confvertical ?? "", value.value)
  }

  return {
    profitCenters,
    selectedProfitCenter,
    ledgerData,
    formData,
    user,
    cloading,
    errors,
    customeroptions,
    handleCustomerChange,
    handleSubmit,
    handleInputChange,
    handleDownloadAll,
    handleProfitCenterChange
  };
};

export default LedgerDivCPIController;